/**
 * Defaults por provider — fonte única de verdade.
 * Usados apenas como fallback quando o banco retorna null
 * (ex: org recém-criada antes do primeiro save).
 *
 * IMPORTANTE: usar IDs com DATA explícita pra evitar 404 da API quando
 * a Anthropic está em transição entre versões dos aliases sem data.
 * Bug histórico: tinha 'claude-sonnet-4-5' (alias sem data) que dava
 * empty response na API porque o alias não estava resolvendo, e o agente
 * morria silenciosamente sem responder.
 */
export const AI_DEFAULT_MODELS = {
  google: 'gemini-2.5-flash',
  openai: 'gpt-4o',
  anthropic: 'claude-haiku-4-5-20251001',
} as const;

export const AI_DEFAULT_PROVIDER = 'google' as const;
